import { observer } from 'src/utils/mobx-react';
import React, { useState } from 'react';
import { MarketTemplateSettingsFormState } from 'src/components/MarketTemplateSettingsForm/MarketTemplateSettingsForm.state';
import { MarketTemplateSettings } from 'src/components/MarketTemplateSettingsForm/Components/MarketTemplateSettings';
import { MarketTemplateTags } from 'src/components/MarketTemplateSettingsForm/Components/MarketTemplateTags';
import { MarketTemplateSelections } from 'src/components/MarketTemplateSettingsForm/Components/MarketTemplateSelections';
import { useAppStateContext } from 'src/AppState/AppState';
import { SportMarketTemplatesState } from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplates.state';
import { SelectionPopup } from 'src/components/SportPopup/SportMarketTemplates/Popup/Popup';
import { MobxMapAutoNew } from 'src_common/common/mobx-utils/MobxMapAutoNew';

export type MarketTemplateSettingsPropsType = {
    sportId: string;
    templateId: string;
    marketTemplatesState: SportMarketTemplatesState;
}

export const MarketTemplateSettingsForm = observer('MarketTemplateSettingsForm', (props: MarketTemplateSettingsPropsType) => {
    const {sdkStaff} = useAppStateContext();
    const [stateResource] = useState(new MobxMapAutoNew((templateId: string) =>  new MarketTemplateSettingsFormState(props, sdkStaff, templateId)));
    const state = stateResource.get(props.templateId);

    return (
        <div className='row form'>
            <MarketTemplateSettings
                marketTemplateSettingsState={state}
            />
            <MarketTemplateSelections
                marketTemplateSettingsState={state}
                marketTemplatesState={props.marketTemplatesState}
            />
            <MarketTemplateTags
                sportId={props.sportId}
                template={props.marketTemplatesState.marketTemplateByIt(props.templateId)}
                onChange={state.onTagChange}
                marketTemplatesState={props.marketTemplatesState}
            />
            { props.marketTemplatesState.openedPopup === 'isSelectionTemplateOpen' ? <SelectionPopup onClose={ props.marketTemplatesState.togglePopup } sportId={props.sportId} templates={props.marketTemplatesState.marketTemplates} marketTemplateId={props.templateId} /> : null }
        </div>
    );
});
